import React from 'react';

const InputField = ({
  id,
  name,
  label,
  value,
  onChange,
  required = false,
  type = 'text',
  disabled = false,
  className = '',
  helperText,
  ...props
}) => (
  <div>
    <label htmlFor={id} className="block text-sm font-medium text-secondary">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <input
      type={type}
      id={id}
      name={name}
      value={value}
      onChange={onChange}
      required={required}
      disabled={disabled}
      className={`mt-1 text-sm block w-full rounded-md py-2 px-3 border border-gray-300 shadow-sm focus:outline-none focus:ring-2 border-color ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''} ${className}`}
      {...props}
    />
    {helperText && <p className="mt-1 text-xs text-gray-500">{helperText}</p>}
  </div>
);

export default InputField;
